import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const SortControls = ({ sortBy, sortOrder, onSortChange, language, resultsCount }) => {
  const sortOptions = [
    { value: 'name', label: language === 'en' ? 'Name' : '名称' },
    { value: 'price', label: language === 'en' ? 'Price' : '价格' },
    { value: 'production_year', label: language === 'en' ? 'Production Year' : '生产年份' },
    { value: 'elevation', label: language === 'en' ? 'Elevation' : '海拔高度' },
    { value: 'country', label: language === 'en' ? 'Country' : '国家' }
  ];

  const handleSortByChange = (value) => {
    onSortChange(value, sortOrder);
  };

  const handleSortOrderToggle = () => {
    const newOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    onSortChange(sortBy, newOrder);
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div className="text-sm text-muted-foreground">
        {language === 'en' 
          ? `Showing ${resultsCount} coffee beans`
          : `显示 ${resultsCount} 种咖啡豆`
        }
      </div>
      
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-foreground whitespace-nowrap">
          {language === 'en' ? 'Sort by:' : '排序:'}
        </span>
        
        <div className="flex items-center gap-2">
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={handleSortByChange}
            placeholder={language === 'en' ? 'Select...' : '选择...'}
            className="min-w-[140px]"
          />
          
          <button
            onClick={handleSortOrderToggle}
            className="p-2 rounded-md border border-border hover:bg-muted transition-smooth"
            aria-label={`Sort ${sortOrder === 'asc' ? 'descending' : 'ascending'}`}
          >
            <Icon 
              name={sortOrder === 'asc' ? 'ArrowUp' : 'ArrowDown'} 
              size={16} 
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortControls;